import { MessagesList } from './types';

export const translations: MessagesList = {
  es: {
    legal: {
      products: {
        despegar: 'Ofertas válidas para compras realizadas el día de hoy. Stock: 4 lugares por destino. DESPEGAR.COM.AR S.A. - CUIT 30-70.130.711-5 –JUJUY 2013.',
      },
      termsAndConditions: {
        title: 'Términos y Condiciones',
        button: 'Aceptar',
        rejectButton: 'En otro momento',
        item1: 'Las respuestas de este chat son generadas automáticamente y pueden contener errores.',
        item2: 'Para requisitos migratorios, te recomendamos contactarte con la autoridad correspondiente.',
        item3: 'Nunca compartas información personal y sensible con el chat.',
        item4: 'Para interactuar, debes aceptar nuestros',
        linkTermsAndConditions: 'términos y condiciones de uso.',
      },
      chat: {
        title: 'Las respuestas del chat son generadas automáticamente y pueden contener errores. Antes de utilizarlo, lee los ',
        button: 'términos y condiciones',
      },
    },
    chat: {
      sandbox: 'Versión sandbox',
      beta: 'Beta',
      sendFeedback: 'Dar mi opinión',
      sendFeedbackUrl: 'https://forms.gle/SfntRNKmYfm8VV1k6',
      openChat: 'Chat',
      textarea: {
        error: {
          message: 'Uy, disculpa, no se qué pasó. ¿Puedes repetirme la pregunta o formular otra?',
          genericRecord: 'No se pudo grabar el audio, por favor intenta nuevamente.',
          permissionRecord: 'No otorgaste permisos para utilizar el microfono, por favor revísalo y vuelve a intentarlo.',
        },
        pauseRecordingAudio: 'Grabación pausada...',
        processingAudio: 'Procesando audio...',
        recordingAudio: 'Grabando audio...',
        placeholder: 'Escribe tu consulta...',
        remaining: (current: number, total: number) => `Te quedan ${current} caracteres.`,
      },
      loadingTexts: {
        initializing: 'Iniciando...',
      },
      error: {
        title: 'No pudimos cargar el chat',
        message: 'Por favor, vuelve a intentar en unos minutos.',
        retry: 'Reintentar',
        expired: {
          title: 'Tu sesión ha expirado',
          message: 'Por favor, inicia un nuevo chat',
          createNewChat: 'Iniciar nuevo chat',
        },
        offline: 'Parece que no tienes conexión a internet. Apenas se restablezca podrás seguir conversando con SOFIA desde donde quedaste.',
      },
      message: {
        requiredLogin: {
          text: 'Muy bien. Para continuar con tu consulta, necesito que inicies sesión.',
          button: 'Iniciar sesión',
        },
        suggestions: {
          title: 'No te preocupes, podemos sugerirte:',
          showMore: 'Ver más',
          showLess: 'Ver menos',
        },
        actions: {
          copy: 'Copiar',
          like: 'Me gusta',
          dislike: 'No me gusta',
          share: 'Compartir',
          debug: 'Debug',
        },
        feedback: {
          upTitle: '¡Qué bueno! ¿Te gustaría cambiar o agregar algo?',
          downTitle: '¿Qué no te gustó y cómo podríamos mejorar?',
          sendButton: 'Enviar respuesta',
          placeholder: 'Ingresa tu respuesta',
          close: 'Cerrar',
        },
      },
    },
    slider: {
      counter: (from: number, to: number) => `${from} de ${to}`,
    },
    boards: {
      newBoard: 'Actualicé el tablero con algunas sugerencias para vos.',
      viewBoard: 'Ver en el tablero',
      loadingTexts: {
        recommendations: 'Buscando recomendaciones...',
        loading: 'Cargando...',
      },
      buy: 'Comprar',
      textViewMore: 'Saber mas',
      specific: {
        offers: {
          send: 'Consultar',
          searchInWeb: 'Buscar en Despegar',
        },
      },
      issues: {
        viewMore: 'Ver más información',
      },
      suggestionDestinations: {
        buttonMoreInfo: 'Saber más',
      },
      flightOffers: {
        viewFlight: 'Ver detalle',
        priceFrom: 'Desde',
        direct: 'Directo',
        duration: 'Duración:',
        withScale: 'Escalas',
        departure: 'Ida',
        return: 'Vuelta',
        viewMore: 'Ver más vuelos',
        distributionModal: {
          error: 'Hubo un problema. Por favor volvé a intentarlo.',
          errorDistribution: 'No hay disponibilidad en este vuelo para esta cantidad de pasajeros. Disculpa las molestias.',
          minors: {
            fare1: 'Tarifa bebe',
            fare2: 'Tarifa niño',
            fare3: 'Tarifa adulto',
          },
          next: 'Ir a pagar',
        },
      },
      priceTrend: {
        noData: 'Sin datos',
        averagePrice: 'Precio promedio',
        lowPrice: 'Precio mas barato',
        fromPrice: (price: string) => `Desde ${price}`,
        error: {
          title: 'Tuvimos un problema',
          description: 'No pudimos cargar la tendencia de precios.',
        },
      },
      accommodationOffers: {
        referenceDate: '1 noche - ',
        book: 'Reservar',
        seeOnMap: 'Ver en mapa',
        distributionModal: {
          next: 'Confirmar',
        },
      },
      activityOffers: {
        pickup: 'Traslado',
        viewActivity: 'Ver detalle',
      },
      packageOffers: {
        duration: {
          stay: {
            days: 'Días',
            nights: 'Noches',
          },
          dates: {
            from: 'Desde',
            to: 'Hasta',
          },
        },
        flight: {
          stops: 'Vuelo con escalas',
          noStops: 'Vuelo directo',
        },
        discountSave: 'Ahorrás',
      },
      map: {
        error: {
          title: 'Error al mostrar el mapa',
          description: 'Vuelve a intentar tu búsqueda.',
        },
        loading: 'Cargando mapa...',
      },
      reservationDetail: {
        booking: 'Reserva',
        reservationNumber: 'N° de reserva de Despegar:',
        reservationCode: {
          hotel: 'N° de reserva del alojamiento:',
          flight: 'N° de reserva de la aerolínea:',
        },
        status: {
          cancelled: 'Cancelada',
          confirmed: 'Confirmada',
          in_process: 'En proceso',
          pending: 'Pendiente',
          affected: 'Afectada',
          provider_control: 'Gestionada por proveedor',
        },
      },
      specialRequest: {
        room: 'Habitación',
        rooms: 'Habitaciones',
        selectRoom: 'Elige en dónde vas a hacer tu pedido especial:',
        selectSpecialRequest: 'Elige el pedido especial',
        placeholder: 'Quiero pedir "{0}" en mi hotel',
        send: 'Enviar a Sofia',
      },
      reschedulingCard: {
        nonstop: 'directo',
        stop: 'escala',
        stops: 'escalas',
        seeFlight: 'Continuar',
        seeAlternatives: 'Ver alternativas',
        seeAlternativesPrompt: 'Quiero ver mas alternativas de reprogramación para mi vuelo',
        duration: 'duración',
        modal: {
          title: 'Confirmación de vuelo',
          flightNumber: 'Vuelo N°',
          showOriginalFlight: 'Mostrar vuelo original',
          hideOriginalFlight: 'Ocultar vuelo original',
          seeAlternatives: 'Ver alternativas',
          buttonConfirmation: 'Confirmar este vuelo',
          layover: (duration: string, city: string) => `Espera de ${duration} en ${city}`,
          waitingAction: 'Estoy procesando tu solicitud para el cambio en tu vuelo, esto puede tardar unos minutos, aguarda por favor.',
          localDateDisclaimer: 'Horario local de cada ciudad.',
          totalDuration: 'Duración',
          layoverWaiting: 'Espera de',
          layoverIn: 'en',
        },
      },
      webCheckIn: {
        title: 'Vuelo a {0}',
      },
      contactBoard: {
        phone: 'Teléfono',
        call: 'Llamar',
        viewPhones: 'Ver teléfonos',
        reservationNumberReminder: 'Recordá tener tu número de reserva a mano.',
        localNumber: 'Llamadas dentro del país:',
        exteriorNumber: 'Llamadas desde el exterior:',
        goToWhatsapp: 'Abrir WhatsApp',
        preferWebchat: 'Si prefieres puedes chatear por',
        phonesModalTitle: 'Nuestros teléfonos',
      },
    },
    productTour: {
      close: 'Entendido',
      next: 'Siguiente',
      prev: 'Anterior',
      initTour: {
        step1: {
          title: 'Conversa con SOFIA',
          text: 'Escribe para consultar lo que quieras: sugerencias de destinos, tips de viajes, vuelos e incluso datos curiosos.',
          text_mobile: 'Toca aquí para hacerle consultas sobre viajes a SOFIA: sugerencias de destinos, tips de viaje o datos curiosos.',
        },
        step2: {
          title: 'Tu tablero de información',
          text: 'Aquí verás información adicional a la respuesta de SOFIA.',
        },
        step3: {
          title: 'Utiliza estas opciones para evitar escribir.',
          text: 'Con estos botones podrás pedir más información sobre ese tema sin necesidad de escribir una pregunta.',
          text_mobile: 'Con estos botones podrás pedir más información sobre ese tema sin necesidad de escribir una pregunta.',
        },
      },
      flightOffers: {
        step1: {
          title: 'Usa el chat para filtrar',
          text: 'Pídele a SOFIA vuelos directos o con escala, con o sin equipaje, solo ida, etc.',
        },
      },
      copyMessage: {
        step1: {
          title: 'Pegamos acá los mensajes que copies',
          text: 'Puedes ajustarlos y enviarlos de nuevo a SOFIA para que te entienda mejor.',
        },
      },
      favProduct: {
        step1: {
          title: 'Toca el corazón para guardar en Favoritos',
        },
      },
      newChat: {
        step1: {
          title: 'Historial y nuevo chat',
          text: 'Ingresa para ver tus conversaciones anteriores o iniciar una nueva.',
        },
      },
    },
    feedbackForm: {
      title: 'Feedback',
      send: 'Enviar',
      placeholder1: 'Escribe aqui..',
      question1: 'En una escala del 0 al 10, ¿cuán probable es que recomiende el Chat IA a un amigo o colega?',
      placeholder2: 'Escribe aqui..',
      question2: '¿Por qué? Nos ayuda muchísimo saber si percibiste algún error, si algo te pareció muy bueno y conocer detalles de tu experiencia.',
      close: 'Cerrar',
    },
    distributionModal: {
      error: 'Hubo un problema. Por favor volvé a intentarlo.',
      errorDistribution: 'No hay disponibilidad para esta cantidad de pasajeros. Disculpa las molestias.',
      title: 'Selecciona los pasajeros',
      adults: {
        title: 'Adultos',
        description: 'Desde 18 años',
      },
      minors: {
        title: 'Menores',
        description: 'Hasta 17 años',
        ageTitle: 'Edad del menor',
        ageDescription: 'Al finalizar el viaje',
        labelSelect: 'Edad',
        underOneAge: 'Hasta 1',
      },
      close: 'Cerrar',
    },
    previousChatModal: {
      title: '¡Qué bueno tenerte de nuevo por aquí!',
      close: 'Cerrar',
      text: 'Veo que estuvimos hablando. ',
      question: '¿Quieres continuar nuestra conversación anterior o iniciar una nueva?',
      cancel: 'Iniciar nueva',
      recover: 'Continuar',
    },
    flightDetailModal: {
      departure: 'Ida',
      return: 'Vuelta',
      cabinType: {
        economy: 'Económica',
        business: 'Business',
        firstclass: 'Primera clase',
        premium_economy: 'Premium Economy',
        premium_business: 'Premium Business',
        premium_firstclass: 'Premium Primera Clase',
      },
      rating: {
        veryGood: 'Muy Bueno',
        good: 'Bueno',
        regular: 'Regular',
        bad: 'Malo',
      },
      duration: 'Duración',
      flight: 'Vuelo',
      class: 'Clase',
      layover: {
        wait: 'Espera de',
        in: 'en',
        planeChange: 'Cambio de avión',
        samePlane: 'Mismo avión',
      },
      localTime: 'Horarios en hora local de cada ciudad',
      baggage: {
        title: 'Equipaje',
        backpack: {
          included: {
            title: 'Incluye una mochila o cartera',
            description: 'Debe caber bajo el asiento delantero.',
          },
          notIncluded: {
            title: 'No incluye mochila o cartera',
            description: '',
          },
        },
        handbag: {
          included: {
            title: 'Incluye equipaje de mano',
            description: 'Debe caber en el compartimiento superior del avión.',
          },
          notIncluded: {
            title: 'No incluye equipaje de mano',
            description: '',
          },
        },
        suitcase: {
          included: {
            title: 'Incluye equipaje para despachar',
            description: (quantity: number) => `${quantity} ${quantity > 1 ? 'valijas' : 'valija'} por adulto. Se despacha en el aeropuerto durante el Check-in.`,
          },
          notIncluded: {
            title: 'No incluye equipaje para despachar',
            description: 'Podrás comprar valijas por un precio exclusivo online.',
          },
        },
      },
    },
    downloadAppModal: {
      subtitle: 'DISPONIBLE EN iOS Y ANDROID',
      title: 'Descarga la app para poder chatear con SOFIA',
      description: 'Descubre cómo nuestra asistente con IA puede ayudarte a encontrar el destino ideal de tus próximas vacaciones.',
      button: 'Descargar ahora',
      href: 'https://m7sd.adj.st/www.despegar.com/sofia?adj_t=1f59te9q_1fpkb7np&adj_campaign=SiteMobile&adj_deep_link=https%3A%2F%2Fwww.despegar.com%2Fsofia%3Fclt_c%3D%26clt_cm%3DSiteMobile%26clt_d%3Dm%26clt_pr%3DG%26clt_cc%3DBR%26clt_n%3Dmd%26key%3DUT81AK9JAFEGJ4D69OVO6J673E',
    },
    editTextModal: {
      title: 'Cambiar título',
      close: 'Cerrar',
      send: 'Cambiar',
      changeTitle: 'Título',
      changeDescription: (location?: string) => `Resumen del día ${location ? `en ${location}` : ''}`,
      error: {
        emptyTitle: 'El título no puede estar vacío',
      },
      prefix: {
        tripTitle: 'Cambiar el título del viaje por:',
        tripDayTitle: day => `Cambiar el título del día ${day} por:`,
        tripDayDescription: (day, location) => `Cambiar la descripción del día ${day} ${location ? `en ${location}` : ''} por:`,
      },
      message: {
        title: '¿Hay algo que quieras cambiar en este día?',
        text: 'Ajustá o borrá los textos, vamos a tenerlos en cuenta para constuir un día perfecto para vos.',
      },
    },
    itineraryMapModal: {
      title: 'Mapa del itinerario',
      close: 'Cerrar',
    },
    tripPlanner: {
      day: 'Día',
      showMap: 'Ver mapa',
      hasFavorite: 'En tus favoritos',
      hasPurchase: 'Tienes una reserva',
      reviews: (quantity: number) => `(${quantity} ${quantity === 1 ? 'reseña' : 'reseñas'} de usuarios)`,
      tips: 'Consejos de viaje',
    },
    chatsDrawer: {
      noChats: 'Aquí encontrarás tus conversaciones con Sofia.',
      newChat: 'Nueva conversación',
      feedback: {
        text: '¿Nos ayudas a mejorar?',
        button: 'Dar mi opinión',
      },
    },
    favorites: {
      success: 'Guardado en Favoritos.',
      info: 'Eliminado de Favoritos.',
      error: 'No pudimos completar la acción. Vuelve a intentarlo. ',
      warning: 'Alcanzaste el máximo de favoritos guardados.',
    },
    select: {
      defaultOption: 'Seleccione una opción',
    },
  },
  es_AR: {
    legal: {
      products: {
        despegar: 'Ofertas válidas para compras realizadas el día de hoy. Stock: 4 lugares por destino. DESPEGAR.COM.AR S.A. - CUIT 30-70.130.711-5 –JUJUY 2013.',
      },
      termsAndConditions: {
        title: 'Términos y Condiciones',
        button: 'Aceptar',
        rejectButton: 'En otro momento',
        item1: 'Las respuestas de este chat son generadas automáticamente y pueden contener errores.',
        item2: 'Para requisitos migratorios, te recomendamos contactarte con la autoridad correspondiente.',
        item3: 'Nunca compartas información personal y sensible con el chat.',
        item4: 'Para interactuar, debés aceptar nuestros',
        linkTermsAndConditions: 'términos y condiciones de uso.',
      },
      chat: {
        title: 'Las respuestas del chat son generadas automáticamente y pueden contener errores. Antes de utilizarlo, lee los ',
        button: 'términos y condiciones',
      },
    },
    chat: {
      sandbox: 'Versión sandbox',
      beta: 'Beta',
      sendFeedback: 'Dar mi opinión',
      sendFeedbackUrl: 'https://forms.gle/SfntRNKmYfm8VV1k6',
      openChat: 'Chat',
      textarea: {
        error: {
          message: 'Uy, se me complicó, disculpá. ¿Me repetís o me hacés otra pregunta?',
          genericRecord: 'No se pudo grabar el audio, por favor intentá nuevamente.',
          permissionRecord: 'No otorgaste permisos para utilizar el microfono, por favor revísalo y vuelve a intentarlo.',
        },
        pauseRecordingAudio: 'Grabación pausada...',
        processingAudio: 'Procesando audio...',
        recordingAudio: 'Grabando audio...',
        placeholder: 'Escribí tu consulta...',
        remaining: (current: number, total: number) => `Te quedan ${current} caracteres.`,
      },
      loadingTexts: {
        initializing: 'Iniciando...',
      },
      error: {
        title: 'No pudimos cargar el chat',
        message: 'Por favor, volvé a intentar en unos minutos.',
        retry: 'Reintentar',
        expired: {
          title: 'Tu sesión ha expirado',
          message: 'Por favor, inicia un nuevo chat',
          createNewChat: 'Iniciar nuevo chat',
        },
        offline: 'Parece que no tienes conexión a internet. Apenas se restablezca podrás seguir conversando con SOFIA desde donde quedaste.',
      },
      message: {
        requiredLogin: {
          text: 'Muy bien. Para continuar con tu consulta, necesito que inicies sesión.',
          button: 'Iniciar sesión',
        },
        suggestions: {
          title: 'No te preocupes, podemos sugerirte:',
          showMore: 'Ver más',
          showLess: 'Ver menos',
        },
        actions: {
          copy: 'Copiar',
          like: 'Me gusta',
          dislike: 'No me gusta',
          share: 'Compartir',
          debug: 'Debug',
        },
        feedback: {
          upTitle: '¡Qué bueno! ¿Te gustaría cambiar o agregar algo?',
          downTitle: '¿Qué no te gustó y cómo podríamos mejorar?',
          sendButton: 'Enviar respuesta',
          placeholder: 'Ingresa tu respuesta',
          close: 'Cerrar',
        },
      },
    },
    slider: {
      counter: (from: number, to: number) => `${from} de ${to}`,
    },
    boards: {
      newBoard: 'Actualicé el tablero con algunas sugerencias para vos.',
      viewBoard: 'Ver en el tablero',
      loadingTexts: {
        recommendations: 'Buscando recomendaciones...',
        loading: 'Cargando...',
      },
      buy: 'Comprar',
      textViewMore: 'Saber mas',
      specific: {
        offers: {
          send: 'Consultar',
          searchInWeb: 'Buscar en Despegar',
        },
      },
      issues: {
        viewMore: 'Ver más información',
      },
      suggestionDestinations: {
        buttonMoreInfo: 'Saber más',
      },
      flightOffers: {
        viewFlight: 'Ver detalle',
        priceFrom: 'Desde',
        direct: 'Directo',
        duration: 'Duración:',
        withScale: 'Escalas',
        departure: 'Ida',
        return: 'Vuelta',
        viewMore: 'Ver más vuelos',
        distributionModal: {
          error: 'Hubo un problema. Por favor volvé a intentarlo.',
          errorDistribution: 'No hay disponibilidad en este vuelo para esta cantidad de pasajeros. Disculpa las molestias.',
          minors: {
            fare1: 'Tarifa bebe',
            fare2: 'Tarifa niño',
            fare3: 'Tarifa adulto',
          },
          next: 'Ir a pagar',
        },
      },
      priceTrend: {
        noData: 'Sin datos',
        averagePrice: 'Precio promedio',
        lowPrice: 'Precio mas barato',
        fromPrice: (price: string) => `Desde ${price}`,
        error: {
          title: 'Tuvimos un problema',
          description: 'No pudimos cargar la tendencia de precios.',
        },
      },
      accommodationOffers: {
        referenceDate: '1 noche - ',
        book: 'Reservar',
        seeOnMap: 'Ver en mapa',
        distributionModal: {
          next: 'Confirmar',
        },
      },
      activityOffers: {
        pickup: 'Traslado',
        viewActivity: 'Ver detalle',
      },
      packageOffers: {
        duration: {
          stay: {
            days: 'Días',
            nights: 'Noches',
          },
          dates: {
            from: 'Desde',
            to: 'Hasta',
          },
        },
        flight: {
          stops: 'Vuelo con escalas',
          noStops: 'Vuelo directo',
        },
        discountSave: 'Ahorrás',
        taxMessage: 'Incluye Percepción RG5617',
      },
      map: {
        error: {
          title: 'Error al mostrar el mapa',
          description: 'Por favor, volvé a intentar tu búsqueda.',
        },
        loading: 'Cargando mapa...',
      },
      reservationDetail: {
        booking: 'Reserva',
        reservationNumber: 'N° de reserva de Despegar:',
        reservationCode: {
          hotel: 'N° de reserva del alojamiento:',
          flight: 'N° de reserva de la aerolínea:',
        },
        status: {
          cancelled: 'Cancelada',
          confirmed: 'Confirmada',
          in_process: 'En proceso',
          pending: 'Pendiente',
          affected: 'Afectada',
          provider_control: 'Gestionada por proveedor',
        },
      },
      specialRequest: {
        room: 'Habitación',
        rooms: 'Habitaciones',
        selectRoom: 'Elige en dónde vas a hacer tu pedido especial:',
        selectSpecialRequest: 'Elige el pedido especial',
        placeholder: 'Quiero pedir "{0}" en mi hotel',
        send: 'Enviar a Sofia',
      },
      reschedulingCard: {
        nonstop: 'directo',
        stop: 'escala',
        stops: 'escalas',
        seeFlight: 'Continuar',
        seeAlternatives: 'Continuar',
        seeAlternativesPrompt: 'Quiero ver mas alternativas de reprogramación para mi vuelo',
        duration: 'duración',
        modal: {
          title: 'Confirmación de vuelo',
          flightNumber: 'Vuelo N°',
          showOriginalFlight: 'Mostrar vuelo original',
          hideOriginalFlight: 'Ocultar vuelo original',
          seeAlternatives: 'Ver alternativas',
          buttonConfirmation: 'Confirmar este vuelo',
          layover: (duration: string, city: string) => `Espera de ${duration} en ${city}`,
          waitingAction: 'Estoy procesando tu solicitud para el cambio en tu vuelo, esto puede tardar unos minutos, aguarda por favor.',
          localDateDisclaimer: 'Horario local de cada ciudad.',
          totalDuration: 'Duración',
          layoverWaiting: 'Espera de',
          layoverIn: 'en',
        },
      },
      webCheckIn: {
        title: 'Vuelo a {0}',
      },
      contactBoard: {
        phone: 'Teléfono',
        call: 'Llamar',
        viewPhones: 'Ver teléfonos',
        reservationNumberReminder: 'Recordá tener tu número de reserva a mano.',
        localNumber: 'Llamadas dentro del país:',
        exteriorNumber: 'Llamadas desde el exterior:',
        goToWhatsapp: 'Abrir WhatsApp',
        preferWebchat: 'Si preferís podés chatear por',
        phonesModalTitle: 'Nuestros teléfonos',
      },
    },
    productTour: {
      close: 'Entendido',
      next: 'Siguiente',
      prev: 'Anterior',
      initTour: {
        step1: {
          title: 'Chateá con SOFIA',
          text: 'Escribí para consultar lo que querés: sugerencias de destinos, tips de viajes, vuelos e incluso datos de color.',
          text_mobile: 'Tocá acá para hacerle consultas sobre viajes a SOFIA: sugerencias de destinos, tips de viaje o datos curiosos.',
        },
        step2: {
          title: 'Tu tablero de información',
          text: 'Acá vas a ver información adicional a la respuesta de SOFIA.',
        },
        step3: {
          title: 'Usá estas opciones para evitar escribir.',
          text: 'Con estos botones podrás pedir más información sobre ese tema sin necesidad de escribir una pregunta.',
          text_mobile: 'Con estos botones podrás pedir más información sobre ese tema sin necesidad de escribir una pregunta.',
        },
      },
      flightOffers: {
        step1: {
          title: 'Usá el chat para filtrar',
          text: 'Pedile a SOFIA vuelos directos o con escala, con o sin equipaje, solo ida, etc.',
        },
      },
      copyMessage: {
        step1: {
          title: 'Pegamos acá los mensajes que copies',
          text: 'Podés ajustarlos y enviarlos de nuevo a SOFIA para que te entienda mejor.',
        },
      },
      favProduct: {
        step1: {
          title: 'Toca el corazón para guardar en Favoritos',
        },
      },
      newChat: {
        step1: {
          title: 'Historial y nuevo chat',
          text: 'Ingresá para ver tus conversaciones anteriores o iniciar una nueva.',
        },
      },
    },
    feedbackForm: {
      title: 'Feedback',
      send: 'Enviar',
      placeholder1: 'Escribe aqui..',
      question1: 'En una escala del 0 al 10, ¿cuán probable es que recomiende el Chat IA a un amigo o colega?',
      placeholder2: 'Escribe aqui..',
      question2: '¿Por qué? Nos ayuda muchísimo saber si percibiste algún error, si algo te pareció muy bueno y conocer detalles de tu experiencia.',
      close: 'Cerrar',
    },
    previousChatModal: {
      title: '¡Qué bueno tenerte de nuevo por acá!',
      close: 'Cerrar',
      text: 'Veo que estuvimos hablando.',
      question: '¿Querés continuar nuestra conversación anterior o iniciar una nueva?',
      cancel: 'Iniciar nueva',
      recover: 'Continuar',
    },
    downloadAppModal: {
      subtitle: 'DISPONIBLE EN iOS Y ANDROID',
      title: 'Descargá la app para poder chatear con SOFIA',
      description: 'Descubrí cómo nuestra asistente con IA puede ayudarte a encontrar el destino ideal de tus próximas vacaciones.',
      button: 'Descargar ahora',
      href: 'https://m7sd.adj.st/www.despegar.com/sofia?adj_t=1f59te9q_1fpkb7np&adj_campaign=SiteMobile&adj_deep_link=https%3A%2F%2Fwww.despegar.com%2Fsofia%3Fclt_c%3D%26clt_cm%3DSiteMobile%26clt_d%3Dm%26clt_pr%3DG%26clt_cc%3DBR%26clt_n%3Dmd%26key%3DUT81AK9JAFEGJ4D69OVO6J673E',
    },
    tripPlanner: {
      day: 'Día',
      showMap: 'Ver mapa',
      hasFavorite: 'En tus favoritos',
      hasPurchase: 'Tenés una reserva',
      reviews: (quantity: number) => `${quantity} ${quantity === 1 ? 'reseña' : 'reseñas'} de usuarios`,
      tips: 'Consejos de viaje',
    },
    chatsDrawer: {
      noChats: 'Acá encontrarás tus conversaciones con Sofia.',
      newChat: 'Nueva conversación',
      feedback: {
        text: '¿Nos ayudás a mejorar?',
        button: 'Dar mi opinión',
      },
    },
    select: {
      defaultOption: 'Seleccione una opción',
    },
  },
  es_MX: {
    legal: {
      chat: {
        title: 'Las respuestas del chat son generadas automáticamente y pueden contener errores. Antes de utilizarlo, lee los ',
        button: 'términos y condiciones',
      },
      termsAndConditions: {
        title: 'Términos y Condiciones',
        button: 'Aceptar',
        rejectButton: 'En otro momento',
        item1: 'Las respuestas de este chat son generadas automáticamente y pueden contener errores.',
        item2: 'Para requisitos migratorios, te recomendamos contactarte con la autoridad correspondiente.',
        item3: 'Nunca compartas información personal y sensible con el chat.',
        item4: 'Para interactuar, debes aceptar nuestros',
        linkTermsAndConditions: 'términos y condiciones de uso.',
      },
      products: {
        despegar:
          'El chat de IA está diseñado para asistirlo en el diseño de su itinerario de viaje, no obstante, cualquier cotización que solicite y realice con la ayuda del chat de IA, no le garantiza que los precios u oferta enviados por el chat de IA estén disponibles o se mantengan, estos pueden sufrir variación de un momento a otro, del chat de IA al canal o sitio de Despegar.',
        bestday:
          'El chat de IA está diseñado para asistirlo en el diseño de su itinerario de viaje, no obstante, cualquier cotización que solicite y realice con la ayuda del chat de IA, no le garantiza que los precios u oferta enviados por el chat de IA estén disponibles o se mantengan, estos pueden sufrir variación de un momento a otro, del chat de IA al canal o sitio de BestDay.',
      },
    },
    chat: {
      sandbox: 'Versión sandbox',
      beta: 'Beta',
      sendFeedback: 'Dar mi opinión',
      sendFeedbackUrl: 'https://forms.gle/SfntRNKmYfm8VV1k6',
      openChat: 'Chat',
      textarea: {
        error: {
          message: 'Uy, disculpa, no se qué pasó. ¿Puedes repetirme la pregunta o formular otra?',
          genericRecord: 'No se pudo grabar el audio, por favor intenta nuevamente.',
          permissionRecord: 'No otorgaste permisos para utilizar el microfono, por favor revísalo y vuelve a intentarlo.',
        },
        pauseRecordingAudio: 'Grabación pausada...',
        processingAudio: 'Procesando audio...',
        recordingAudio: 'Grabando audio...',
        placeholder: 'Escribe tu pregunta...',
        remaining: (current: number, total: number) => `Te quedan ${current} caracteres.`,
      },
      loadingTexts: {
        initializing: 'Iniciando...',
      },
      error: {
        title: 'No pudimos cargar el chat',
        message: 'Por favor, prueba de nuevo en unos minutitos.',
        retry: 'Reintentar',
        expired: {
          title: 'Tu sesión ha expirado',
          message: 'Por favor, inicia un nuevo chat',
          createNewChat: 'Iniciar nuevo chat',
        },
        offline: 'Parece que no tienes conexión a internet. Apenas se restablezca podrás seguir conversando con SOFIA desde donde quedaste.',
      },
      message: {
        requiredLogin: {
          text: 'Muy bien. Para continuar con tu consulta, necesito que inicies sesión.',
          button: 'Iniciar sesión',
        },
        suggestions: {
          title: 'No te preocupes, podemos sugerirte:',
          showMore: 'Ver más',
          showLess: 'Ver menos',
        },
        actions: {
          copy: 'Copiar',
          like: 'Me gusta',
          dislike: 'No me gusta',
          share: 'Compartir',
          debug: 'Debug',
        },
        feedback: {
          upTitle: '¡Qué bueno! ¿Te gustaría cambiar o agregar algo?',
          downTitle: '¿Qué no te gustó y cómo podríamos mejorar?',
          sendButton: 'Enviar respuesta',
          placeholder: 'Ingresa tu respuesta',
          close: 'Cerrar',
        },
      },
    },
    slider: {
      counter: (from: number, to: number) => `${from} de ${to}`,
    },
    boards: {
      newBoard: 'Actualicé el tablero con algunas sugerencias para vos.',
      viewBoard: 'Ver en el tablero',
      loadingTexts: {
        recommendations: 'Buscando recomendaciones...',
        loading: 'Cargando...',
      },
      buy: 'Comprar',
      textViewMore: 'Saber mas',
      specific: {
        offers: {
          send: 'Preguntar',
          searchInWeb: 'Buscar en Despegar',
        },
      },
      issues: {
        viewMore: 'Ver más información',
      },
      suggestionDestinations: {
        buttonMoreInfo: 'Saber más',
      },
      flightOffers: {
        viewFlight: 'Ver detalle',
        priceFrom: 'Desde',
        direct: 'Directo',
        duration: 'Duración:',
        withScale: 'Escalas',
        departure: 'Ida',
        return: 'Vuelta',
        viewMore: 'Ver más vuelos',
        distributionModal: {
          error: 'Hubo un problema. Por favor volvé a intentarlo.',
          errorDistribution: 'No hay disponibilidad en este vuelo para esta cantidad de pasajeros. Disculpa las molestias.',
          minors: {
            fare1: 'Tarifa bebe',
            fare2: 'Tarifa niño',
            fare3: 'Tarifa adulto',
          },
          next: 'Ir a pagar',
        },
      },
      priceTrend: {
        noData: 'Sin datos',
        averagePrice: 'Precio promedio',
        lowPrice: 'Precio mas barato',
        fromPrice: (price: string) => `Desde ${price}`,
        error: {
          title: 'Tuvimos un problema',
          description: 'No pudimos cargar la tendencia de precios.',
        },
      },
      accommodationOffers: {
        referenceDate: '1 noche - ',
        book: 'Reservar',
        seeOnMap: 'Ver en mapa',
        distributionModal: {
          next: 'Confirmar',
        },
      },
      activityOffers: {
        pickup: 'Traslado',
        viewActivity: 'Ver detalle',
      },
      packageOffers: {
        duration: {
          stay: {
            days: 'Días',
            nights: 'Noches',
          },
          dates: {
            from: 'Desde',
            to: 'Hasta',
          },
        },
        flight: {
          stops: 'Vuelo con escalas',
          noStops: 'Vuelo directo',
        },
        discountSave: 'Ahorrás',
      },
      map: {
        error: {
          title: 'Error al mostrar el mapa',
          description: 'Vuelve a intentar tu búsqueda.',
        },
        loading: 'Cargando mapa...',
      },
      reservationDetail: {
        booking: 'Reserva',
        reservationNumber: 'N° de reserva de Despegar:',
        reservationCode: {
          hotel: 'N° de reserva del alojamiento:',
          flight: 'N° de reserva de la aerolínea:',
        },
        status: {
          cancelled: 'Cancelada',
          confirmed: 'Confirmada',
          in_process: 'En proceso',
          pending: 'Pendiente',
          affected: 'Afectada',
          provider_control: 'Gestionada por proveedor',
        },
      },
      specialRequest: {
        room: 'Habitación',
        rooms: 'Habitaciones',
        selectRoom: 'Elige en dónde vas a hacer tu pedido especial:',
        selectSpecialRequest: 'Elige el pedido especial',
        placeholder: 'Quiero pedir "{0}" en mi hotel',
        send: 'Enviar a Sofia',
      },
      reschedulingCard: {
        nonstop: 'directo',
        stop: 'escala',
        stops: 'escalas',
        seeFlight: 'Continuar',
        seeAlternatives: 'Continuar',
        seeAlternativesPrompt: 'Quiero ver mas alternativas de reprogramación para mi vuelo',
        duration: 'duración',
        modal: {
          title: 'Confirmación de vuelo',
          flightNumber: 'Vuelo N°',
          showOriginalFlight: 'Mostrar vuelo original',
          hideOriginalFlight: 'Ocultar vuelo original',
          seeAlternatives: 'Ver alternativas',
          buttonConfirmation: 'Confirmar este vuelo',
          layover: (duration: string, city: string) => `Espera de ${duration} en ${city}`,
          waitingAction: 'Estoy procesando tu solicitud para el cambio en tu vuelo, esto puede tardar unos minutos, aguarda por favor.',
          localDateDisclaimer: 'Horario local de cada ciudad.',
          totalDuration: 'Duración',
          layoverWaiting: 'Espera de',
          layoverIn: 'en',
        },
      },
      webCheckIn: {
        title: 'Vuelo a {0}',
      },
      contactBoard: {
        phone: 'Teléfono',
        call: 'Llamar',
        viewPhones: 'Ver teléfonos',
        reservationNumberReminder: 'Recordá tener tu número de reserva a mano.',
        localNumber: 'Llamadas dentro del país:',
        exteriorNumber: 'Llamadas desde el exterior:',
        goToWhatsapp: 'Abrir WhatsApp',
        preferWebchat: 'Si prefieres puedes chatear por',
        phonesModalTitle: 'Nuestros teléfonos',
      },
    },
    productTour: {
      close: 'Entendido',
      next: 'Siguiente',
      prev: 'Anterior',
      initTour: {
        step1: {
          title: 'Platica con SOFIA',
          text: 'Saca tus dudas de viaje: recomendación de destinos, tips de viaje, vuelos o hasta datos curiosos.',
          text_mobile: 'Toca aquí para hacer preguntas sobre viajes a SOFIA: sugerencias de destinos, tips de viaje o datos curiosos.',
        },
        step2: {
          title: 'Tu tablero de información',
          text: 'Aquí verás información adicional a la respuesta de SOFIA.',
        },
        step3: {
          title: 'Usa estas opciones para avanzar más rápido.',
          text: 'Con estos botones podrás pedir más información sobre ese tema sin necesidad de escribir una pregunta.',
          text_mobile: 'Con estos botones podrás pedir más información sobre ese tema sin necesidad de escribir una pregunta.',
        },
      },
      flightOffers: {
        step1: {
          title: 'Usa el chat para filtrar',
          text: 'Pídele a SOFIA vuelos directos o con escala, con o sin equipaje, solo ida, etc.',
        },
      },
      copyMessage: {
        step1: {
          title: 'Pegamos acá los mensajes que copies',
          text: 'Puedes ajustarlos y enviarlos de nuevo a SOFIA para que te entienda mejor.',
        },
      },
      favProduct: {
        step1: {
          title: 'Toca el corazón para guardar en Favoritos',
        },
      },
      newChat: {
        step1: {
          title: 'Historial y nuevo chat',
          text: 'Ingresa para ver tus conversaciones anteriores o iniciar una nueva.',
        },
      },
    },
    feedbackForm: {
      title: 'Feedback',
      send: 'Enviar',
      placeholder1: 'Escribe aqui..',
      question1: 'En una escala del 0 al 10, ¿cuán probable es que recomiende el Chat IA a un amigo o colega?',
      placeholder2: 'Escribe aqui..',
      question2: '¿Por qué? Nos ayuda muchísimo saber si percibiste algún error, si algo te pareció muy bueno y conocer detalles de tu experiencia.',
      close: 'Cerrar',
    },
    select: {
      defaultOption: 'Seleccione una opción',
    },
  },
  es_CL: {
    legal: {
      products: {
        despegar: 'Estas ofertas solo aplican a productos de las mismas características indicadas en la oferta y que sean comprados hoy en www.despegar.cl. Stock de 5 unidades.',
        falabella: 'Ofertas válidas para compras realizadas el día de hoy. Stock: 5 lugares. ViajesFalabella.cl',
      },
      termsAndConditions: {
        title: 'Términos y Condiciones',
        button: 'Aceptar',
        rejectButton: 'En otro momento',
        item1: 'Las respuestas de este chat son generadas automáticamente y pueden contener errores.',
        item2: 'Para requisitos migratorios, te recomendamos contactarte con la autoridad correspondiente.',
        item3: 'Nunca compartas información personal y sensible con el chat.',
        item4: 'Para interactuar, debes aceptar nuestros',
        linkTermsAndConditions: 'términos y condiciones de uso.',
      },
      chat: {
        title: 'Las respuestas del chat son generadas automáticamente y pueden contener errores. Antes de utilizarlo, lee los ',
        button: 'términos y condiciones',
      },
    },
  },
  es_CO: {
    legal: {
      products: {
        despegar: 'Ofertas válidas para compras realizadas el día de hoy. Stock: 5 lugares. Despegar Colombia S.A.S.',
        falabella: 'Ofertas válidas para compras realizadas el día de hoy. Stock: 5 lugares. ViajesFalabella.com.co',
      },
      termsAndConditions: {
        title: 'Términos y Condiciones',
        button: 'Aceptar',
        rejectButton: 'En otro momento',
        item1: 'Las respuestas de este chat son generadas automáticamente y pueden contener errores.',
        item2: 'Para requisitos migratorios, te recomendamos contactarte con la autoridad correspondiente.',
        item3: 'Nunca compartas información personal y sensible con el chat.',
        item4: 'Para interactuar, debes aceptar nuestros',
        linkTermsAndConditions: 'términos y condiciones de uso.',
      },
      chat: {
        title: 'Las respuestas del chat son generadas automáticamente y pueden contener errores. Antes de utilizarlo, lee los ',
        button: 'términos y condiciones',
      },
    },
  },
  es_PE: {
    legal: {
      products: {
        despegar: 'Ofertas válidas para compras realizadas el día de hoy. Stock 5 lugares. Tipo de cambio referencial 4.0. DESPEGAR.COM PERU S.A.C.',
        falabella: 'Ofertas válidas para compras realizadas el día de hoy. Stock 5 lugares. Tipo de cambio referencial 4.0. viajesfalabella.com.pe',
      },
      termsAndConditions: {
        title: 'Términos y Condiciones',
        button: 'Aceptar',
        rejectButton: 'En otro momento',
        item1: 'Las respuestas de este chat son generadas automáticamente y pueden contener errores.',
        item2: 'Para requisitos migratorios, te recomendamos contactarte con la autoridad correspondiente.',
        item3: 'Nunca compartas información personal y sensible con el chat.',
        item4: 'Para interactuar, debes aceptar nuestros',
        linkTermsAndConditions: 'términos y condiciones de uso.',
      },
      chat: {
        title: 'Las respuestas del chat son generadas automáticamente y pueden contener errores. Antes de utilizarlo, lee los ',
        button: 'términos y condiciones',
      },
    },
  },
  es_EC: {
    legal: {
      products: {
        despegar: 'Ofertas válidas para compras realizadas el día de hoy. Stock: 5 lugares. DespegarEcuador S.A.',
      },
      termsAndConditions: {
        title: 'Términos y Condiciones',
        button: 'Aceptar',
        rejectButton: 'En otro momento',
        item1: 'Las respuestas de este chat son generadas automáticamente y pueden contener errores.',
        item2: 'Para requisitos migratorios, te recomendamos contactarte con la autoridad correspondiente.',
        item3: 'Nunca compartas información personal y sensible con el chat.',
        item4: 'Para interactuar, debes aceptar nuestros',
        linkTermsAndConditions: 'términos y condiciones de uso.',
      },
      chat: {
        title: 'Las respuestas del chat son generadas automáticamente y pueden contener errores. Antes de utilizarlo, lee los ',
        button: 'términos y condiciones',
      },
    },
  },
  es_UY: {
    legal: {
      products: {
        despegar: 'Ofertas válidas para compras realizadas el día de hoy. Stock: 4 lugares por destino. DESPEGAR.COM.AR S.A. - CUIT 30-70.130.711-5 –JUJUY 2013.',
      },
      termsAndConditions: {
        title: 'Términos y Condiciones',
        button: 'Aceptar',
        rejectButton: 'En otro momento',
        item1: 'Las respuestas de este chat son generadas automáticamente y pueden contener errores.',
        item2: 'Para requisitos migratorios, te recomendamos contactarte con la autoridad correspondiente.',
        item3: 'Nunca compartas información personal y sensible con el chat.',
        item4: 'Para interactuar, debes aceptar nuestros',
        linkTermsAndConditions: 'términos y condiciones de uso.',
      },
      chat: {
        title: 'Las respuestas del chat son generadas automáticamente y pueden contener errores. Antes de utilizarlo, lee los ',
        button: 'términos y condiciones',
      },
    },
  },
  pt: {
    legal: {
      products: {
        despegar:
          'Qualquer cotação com a ajuda do chat de IA não garante a disponibilidade de os preços ou ofertas apresentados, pois podem variar durante a sua interação com o chat de IA. O mesmo pode ocorrer ao se direcionar do chat de IA para o canal de vendas, inclusive no site Decolar.',
        viajanet:
          'Qualquer cotação com a ajuda do chat de IA não garante a disponibilidade de os preços ou ofertas apresentados, pois podem variar durante a sua interação com o chat de IA. O mesmo pode ocorrer ao se direcionar do chat de IA para o canal de vendas, inclusive no site ViajaNet.',
      },
      chat: {
        title: 'As respostas do chat são geradas automaticamente e podem conter erros. Antes de utilizá-lo, leia os ',
        button: 'termos e condições',
      },
      termsAndConditions: {
        title: 'Termos e Condições',
        button: 'Aceitar',
        rejectButton: 'Em outro momento',
        item1: 'As respostas deste chat são geradas automaticamente e podem conter erros.',
        item2: 'Para requisitos migratórios, te recomendamos contactar a autoridade correspondente.',
        item3: 'Nunca compartilhe informações pessoais e sensíveis com o chat.',
        item4: 'Para interagir, você deve aceitar nossos',
        linkTermsAndConditions: 'termos e condições de uso.',
      },
    },
    chat: {
      sandbox: 'Versão sandbox',
      beta: 'Beta',
      sendFeedback: 'Enviar minha opinião',
      sendFeedbackUrl: 'https://forms.gle/attx8MpS97fgG4LA7',
      openChat: 'Chat',
      textarea: {
        error: {
          genericRecord: 'Me fui por um minuto, desculpa! Você poderia repetir ou fazer outra pergunta?',
          permissionRecord: 'Você não concedeu permissões para usar o microfone. Conceda-as e tente novamente.',
          message: 'Não foi possível enviar a mensagem, por favor tente novamente',
        },
        pauseRecordingAudio: 'Gravação pausada...',
        processingAudio: 'Processando áudio...',
        recordingAudio: 'Gravando áudio...',
        placeholder: 'Escreva a sua pergunta...',
        remaining: (current: number, total: number) => `Você pode escrever mais ${current} caracteres.`,
      },
      loadingTexts: {
        initializing: 'Iniciando...',
      },
      error: {
        title: 'Ocorreu um erro e a SOFIA não está disponível neste momento.',
        message: 'Por favor, tente novamente dentro de alguns minutos.',
        retry: 'Tentar novamente',
        expired: {
          title: 'Seu chat expirou',
          message: 'Você deve iniciar um novo chat',
          createNewChat: 'Iniciar novo chat',
        },
        offline: 'Parece que você está sem conexão com a internet. Assim que ela for restabelecida, você poderá continuar conversando com a SOFIA de onde parou.',
      },
      message: {
        requiredLogin: {
          text: 'Perfeito. Para continua com sua consulta, preciso que você inicie sessão.',
          button: 'Iniciar sessão',
        },
        suggestions: {
          title: 'Não se preocupe, podemos sugerir:',
          showMore: 'Ver mais',
          showLess: 'Ver menos',
        },
        actions: {
          copy: 'Copiar',
          like: 'Gostei',
          dislike: 'Não gostei',
          share: 'Compartilhar',
          debug: 'Debug',
        },
        feedback: {
          upTitle: 'Que ótimo! Você melhoraria ou acrescentaria alguma coisa?',
          downTitle: 'O que você não gostou e como podemos melhorar?',
          sendButton: 'Enviar resposta',
          placeholder: 'Escreva seu texto aqui',
          close: 'Fechar',
        },
      },
    },
    slider: {
      counter: (from: number, to: number) => `${from} de ${to}`,
    },
    boards: {
      newBoard: 'Atualizei meu quadro com algumas sugestões para você.',
      viewBoard: 'Ver recomendações',
      loadingTexts: {
        recommendations: 'Procurando recomendações...',
        loading: 'Carregando...',
      },
      buy: 'Comprar',
      textViewMore: 'Saber mais',
      specific: {
        offers: {
          send: 'Perguntar',
          searchInWeb: 'Pesquisar na Decolar',
        },
      },
      issues: {
        viewMore: 'Veja mais informações',
      },
      suggestionDestinations: {
        buttonMoreInfo: 'Saber mais',
      },
      flightOffers: {
        viewFlight: 'Ver detalhe',
        priceFrom: 'A partir de',
        duration: 'Duração:',
        direct: 'Direto',
        withScale: 'Paradas',
        departure: 'Ida',
        return: 'Volta',
        viewMore: 'Buscar mais voos',
        distributionModal: {
          error: 'Não foi possível, por favor tente novamente',
          errorDistribution: 'Não há mais disponibilidade no voo para esta quantidade de passageiros. Desculpe pelo incômodo.',
          minors: {
            fare1: 'Tarifa bebê',
            fare2: 'Tarifa crianças',
            fare3: 'Tarifa adulto',
          },
          next: 'Ir ao pagamento',
        },
      },
      priceTrend: {
        noData: 'Não há dados',
        averagePrice: 'Preço médio',
        lowPrice: 'Preço mais baixo',
        fromPrice: (price: string) => `A partir de ${price}`,
        error: {
          title: 'Ocorreu um erro',
          description: 'Por favor, tente novamente dentro de alguns minutos.',
        },
      },
      accommodationOffers: {
        referenceDate: '1 noite - ',
        book: 'Reservar',
        seeOnMap: 'Ver no mapa',
        distributionModal: {
          next: 'Confirmar',
        },
      },
      activityOffers: {
        pickup: 'Transfer',
        viewActivity: 'Ver detalhe',
      },
      packageOffers: {
        duration: {
          stay: {
            days: 'Dias',
            nights: 'Noites',
          },
          dates: {
            from: 'De',
            to: 'A',
          },
        },
        flight: {
          stops: 'Voo com escalas',
          noStops: 'Voo direto',
        },
        discountSave: 'Salva',
      },
      map: {
        error: {
          title: 'Erro ao exibir o mapa',
          description: 'Por favor, tente sua busca novamente.',
        },
        loading: 'Carregando o mapa...',
      },
      reservationDetail: {
        booking: 'Reserva',
        reservationNumber: 'N° de reserva do Decolar:',
        reservationCode: {
          hotel: 'N° de reserva de alojamento:',
          flight: 'N° de reserva da companhia aérea:',
        },
        status: {
          cancelled: 'Cancelada',
          confirmed: 'Confirmada',
          in_process: 'Em processo',
          pending: 'Pendente',
          affected: 'Afetada',
          provider_control: 'Administrada pelo fornecedor',
        },
      },
      specialRequest: {
        room: 'Quarto',
        rooms: 'Quartos',
        selectRoom: 'Escolha onde você vai fazer seu pedido especial:',
        selectSpecialRequest: 'Escolha um pedido especial',
        placeholder: 'Quero adicionar "{0}" ao meu hotel',
        send: 'Enviar para Sofia',
      },
      reschedulingCard: {
        nonstop: 'sem escalas',
        stop: 'parada',
        stops: 'paradas',
        seeFlight: 'Continuar',
        seeAlternatives: 'Continuar',
        seeAlternativesPrompt: 'Quero ver mais alternativas de reprogramação para o meu voo',
        duration: 'duração',
        modal: {
          title: 'Confirmação de voo',
          flightNumber: 'N° do voo',
          showOriginalFlight: 'Mostrar voo original',
          hideOriginalFlight: 'Ocultar voo original',
          seeAlternatives: 'Ver alternativas',
          buttonConfirmation: 'Confirme este voo',
          layover: (duration: string, city: string) => `Espera de ${duration} em ${city}`,
          waitingAction: 'Estou processando sua solicitação de alteração de voo, isso pode levar alguns minutos, por favor aguarde.',
          localDateDisclaimer: 'Horário local de cada cidade.',
          totalDuration: 'Duração',
          layoverWaiting: 'Espera de',
          layoverIn: 'em',
        },
      },
      webCheckIn: {
        title: 'Voo para {0}',
      },
      contactBoard: {
        phone: 'Telefone',
        call: 'Chamar',
        viewPhones: 'Ver telefone',
        reservationNumberReminder: 'Lembre-se de estar com o número da reserva em mãos.',
        localNumber: 'Ligação local:',
        exteriorNumber: 'Ligação do exterior:',
        goToWhatsapp: 'Abrir WhatsApp',
        preferWebchat: 'Se preferir, pode conversar pelo',
        phonesModalTitle: 'Nossos telefones',
      },
    },
    productTour: {
      close: 'Entendido',
      next: 'Próximo',
      prev: 'Anterior',
      initTour: {
        step1: {
          title: 'Bata um papo com a SOFIA',
          text: 'Pergunte sobre ideias de viagem, ex: sugestões de destino, dicas de viagem, voos e informações relevantes.',
          text_mobile: 'Clique para começar a conversar com a SOFIA sobre a sua viagem.',
        },
        step2: {
          title: 'Recomendações e informação extra da SOFIA',
          text: 'Aqui você pode ver informação adicional sobre o que está falando com a SOFIA.',
        },
        step3: {
          title: 'Use estas opções para não precisar escrever',
          text: 'Neste espaço você pode selecionar rapidamente perguntas para a SOFIA, além de ver informações adicionais.',
          text_mobile: 'Neste espaço você pode selecionar rapidamente perguntas para a SOFIA, além de ver informações adicionais.',
        },
      },
      flightOffers: {
        step1: {
          title: 'Use o chat para filtrar',
          text: 'Peça à SOFIA voos diretos ou com escala, com ou sem bagagem para despachar, somente ida, etc.',
        },
      },
      copyMessage: {
        step1: {
          title: 'Colamos aqui as mensagens que você copiar',
          text: 'Você pode ajustá-las e enviá-las novamente para a SOFIA para que ela entenda melhor.',
        },
      },
      favProduct: {
        step1: {
          title: 'Toque no coração para salvar nos Favoritos',
        },
      },
      newChat: {
        step1: {
          title: 'Histórico e novo chat',
          text: 'Veja suas conversas anteriores ou comece uma nova.',
        },
      },
    },
    feedbackForm: {
      title: 'Feedback',
      send: 'Enviar',
      placeholder1: 'Escreva aqui...',
      question1: 'Em uma escala de 1 a 10, o quanto você indicaria nosso Chat AI para um amigo ou colega?',
      placeholder2: 'Escreva aqui...',
      question2: 'Por quê? Nos ajuda muito saber se você percebeu algum erro, se algo lhe pareceu muito bom e conhecer detalhes da sua experiência.',
      close: 'Cerrar',
    },
    distributionModal: {
      error: 'Não foi possível, por favor tente novamente',
      errorDistribution: 'Não há mais disponibilidade para esta quantidade de passageiros. Desculpe pelo incômodo.',
      title: 'Selecione os passageiros',
      adults: {
        title: 'Adultos',
        description: 'A partir dos 18 anos',
      },
      minors: {
        title: 'Crianças',
        description: 'Até os 17 anos',
        ageTitle: 'Idade da criança',
        ageDescription: 'Ao finalizar da viagem',
        labelSelect: 'Idade',
        underOneAge: 'Até 1',
      },
      close: 'Ok',
    },
    previousChatModal: {
      title: 'Que bom ter você de volta aqui!',
      close: 'Ok',
      text: 'Vejo que estávamos conversando.',
      question: 'Você quer continuar nossa conversa anterior ou iniciar uma nova?',
      cancel: 'Iniciar nova',
      recover: 'Continuar',
    },
    flightDetailModal: {
      departure: 'Ida',
      return: 'Volta',
      cabinType: {
        economy: 'Econômica',
        business: 'Business',
        firstclass: 'Primeira Classe',
        premium_economy: 'Premium Economy',
        premium_business: 'Premium Business',
        premium_firstclass: 'Premium Primeira Classe',
      },
      rating: {
        veryGood: 'Muito Bom',
        good: 'Bom',
        regular: 'Regular',
        bad: 'Ruim',
      },
      duration: 'Duração',
      flight: 'Voo',
      class: 'Classe',
      layover: {
        wait: 'Espera de',
        in: 'em',
        planeChange: 'Troca de avião',
        samePlane: 'Mesmo avião',
      },
      localTime: 'Horários em hora local de cada cidade',
      baggage: {
        title: 'Bagagem',
        backpack: {
          included: {
            title: 'Inclui uma mochila ou bolsa',
            description: 'Deve caber embaixo do assento dianteiro.',
          },
          notIncluded: {
            title: 'Não inclui mochila ou bolsa',
            description: '',
          },
        },
        handbag: {
          included: {
            title: 'Inclui bagagem de mão',
            description: 'Deve caber no compartimento superior do avião.',
          },
          notIncluded: {
            title: 'Não inclui bagagem de mão',
            description: '',
          },
        },
        suitcase: {
          included: {
            title: 'Inclui bagagem para despachar',
            description: (quantity: number) => `${quantity} ${quantity > 1 ? 'malas' : 'mala'} por adulto. O despache é feito durante o Check-in no aeroporto.`,
          },
          notIncluded: {
            title: 'Não inclui bagagem para despachar',
            description: 'Você poderá adicionar malas por um valor adicional quando chegar ao aeroporto.',
          },
        },
      },
    },
    downloadAppModal: {
      subtitle: 'DISPONIBLE EN iOS Y ANDROID',
      title: 'Baixe o app para poder conversar com a SOFIA',
      description: 'Descubra como a nossa assistente de IA pode te ajudar a encontrar o destino ideal para as suas próximas férias.',
      button: 'Baixar agora',
      href: 'https://geja.adj.st/www.decolar.com/sofia?adj_t=1fmnqbux_1fxwjiyp&adj_campaign=SiteMobile&adj_deep_link=https%3A%2F%2Fwww.decolar.com%2Fsofia%3Fclt_c%3D%26clt_cm%3DSiteMobile%26clt_d%3Dm%26clt_pr%3DG%26clt_cc%3DBR%26clt_n%3D1%26key%3DUT81AK9JAFEGJ4D69OVO6J673E',
    },
    editTextModal: {
      title: 'Alterar título',
      close: 'Fechar',
      send: 'Alterar',
      changeTitle: 'Título',
      changeDescription: (location?: string) => `Resumo do dia ${location ? `em ${location}` : ''}`,
      error: {
        emptyTitle: 'O título não pode estar vazio',
      },
      prefix: {
        tripTitle: 'Altere o título da viagem para:',
        tripDayTitle: day => `Altere o título do dia ${day} para:`,
        tripDayDescription: (day, location) => `Altere a descrição do dia ${day} ${location ? `em ${location}` : ''} para:`,
      },
      message: {
        title: 'Tem alguma coisa que você quer mudar hoje?',
        text: 'Ajuste ou exclua os textos, nós os levaremos em consideração para construir um dia perfeito para você.',
      },
    },
    itineraryMapModal: {
      title: 'Mapa do itinerário',
      close: 'Fechar',
    },
    tripPlanner: {
      day: 'Dia',
      showMap: 'Ver mapa',
      hasFavorite: 'Nos seus favoritos',
      hasPurchase: 'Você tem uma reserva',
      reviews: (quantity: number) => `${quantity} ${quantity === 1 ? 'comentário' : 'comentários'} de usuarios`,
      tips: 'Dicas de viagem',
    },
    chatsDrawer: {
      noChats: 'Aqui você encontrará suas conversas com Sofia.',
      newChat: 'Iniciar nova conversa',
      feedback: {
        text: 'Você pode nos ajudar a melhorar?',
        button: 'Enviar minha opinião',
      },
    },
    favorites: {
      success: 'Salvo em Favoritos.',
      info: 'Removido dos Favoritos.',
      error: 'Não conseguimos completar a ação. Por favor, tente novamente.',
      warning: 'Você atingiu o número máximo de favoritos salvos.',
    },
    select: {
      defaultOption: 'Selecione uma opção',
    },
  },
  en: {
    legal: {
      chat: {
        title: 'The chat responses are generated automatically and may contain errors. Before using it, read the ',
        button: 'terms and conditions',
      },
      termsAndConditions: {
        title: 'Terms and Conditions',
        button: 'Accept',
        rejectButton: 'At another time',
        item1: 'The responses in this chat are automatically generated and may contain errors.',
        item2: 'For immigration requirements, we recommend contacting the corresponding authority.',
        item3: 'Never share personal and sensitive information with the chat.',
        item4: 'To interact, you must accept our',
        linkTermsAndConditions: 'terms and conditions of use.',
      },
      products: {
        despegar:
          'All quotes, indexes, and any other values published on this website are for informational purposes and are indicative, so they should only be taken as reference.',
      },
    },
    chat: {
      sandbox: 'Sandbox version',
      beta: 'Beta',
      sendFeedback: 'Send feedback',
      sendFeedbackUrl: 'https://forms.gle/SfntRNKmYfm8VV1k6',
      openChat: 'Chat',
      textarea: {
        error: {
          message: "Oops, sorry, I don't know what happened. Can you repeat the question or ask another?",
          genericRecord: "We couldn't record the audio, please try again.",
          permissionRecord: "You didn't grant permission to use the microphone, please grant it and try again.",
        },
        pauseRecordingAudio: 'Recording paused...',
        processingAudio: 'Processing audio...',
        recordingAudio: 'Recording audio...',
        placeholder: 'Enter your query...',
        remaining: (current: number, total: number) => `${current} of ${total} characters remaining.`,
      },
      loadingTexts: {
        initializing: 'Initializing chat...',
      },
      error: {
        title: "We couldn't load the chat right now",
        message: 'We apologize, you can retry or try again in a few minutes.',
        retry: 'Retry',
        expired: {
          title: 'Your chat has expired',
          message: 'You will need to start a new chat',
          createNewChat: 'Start a new chat',
        },
        offline: 'It looks like you don’t have an internet connection. Once it’s back, you’ll be able to continue your conversation with SOFIA right where you left off.',
      },
      message: {
        requiredLogin: {
          text: 'Great.To proceed with your request, I need you to sign in.',
          button: 'Sign in',
        },
        suggestions: {
          title: "Don't worry, we can suggest:",
          showMore: 'Show more',
          showLess: 'Show less',
        },
        actions: {
          copy: 'Copy',
          like: 'Like',
          dislike: 'Dislike',
          share: 'Share',
          debug: 'Debug',
        },
        feedback: {
          upTitle: 'Would you like to improve or change something?',
          downTitle: 'How can we improve?',
          sendButton: 'Send',
          placeholder: 'Enter your text here',
          close: 'Close',
        },
      },
    },
    slider: {
      counter: (from: number, to: number) => `${from} of ${to}`,
    },
    boards: {
      newBoard: 'I updated my board with some suggestions for you.',
      viewBoard: 'View board',
      loadingTexts: {
        recommendations: 'Searching recommendations...',
        loading: 'Loading...',
      },
      buy: 'Buy',
      textViewMore: 'Learn more',
      specific: {
        offers: {
          send: 'Send',
          searchInWeb: 'Search on the web',
        },
      },
      issues: {
        viewMore: 'See more information',
      },
      suggestionDestinations: {
        buttonMoreInfo: 'More info',
      },
      flightOffers: {
        viewFlight: 'See detail',
        priceFrom: 'From',
        duration: 'Duration:',
        direct: 'Direct',
        withScale: 'With scales',
        departure: 'Depart.',
        return: 'Return',
        viewMore: 'View more flights',
        distributionModal: {
          error: 'We had a problem. Please try again.',
          errorDistribution: 'There is no availability on this flight for this number of passengers. Sorry for the inconvenience.',
          minors: {
            fare1: 'Baby fare',
            fare2: 'Child fare',
            fare3: 'Adult fare',
          },
          next: 'Go to checkout',
        },
      },
      priceTrend: {
        noData: 'No data',
        averagePrice: 'Average price',
        lowPrice: 'Cheapest price',
        fromPrice: (price: string) => `From ${price}`,
        error: {
          title: 'An error occurred',
          description: 'Could not load the price trend chart',
        },
      },
      accommodationOffers: {
        referenceDate: '1 night -',
        book: 'Book',
        seeOnMap: 'See on map',
        distributionModal: {
          next: 'Confirm',
        },
      },
      activityOffers: {
        pickup: 'Transfer',
        viewActivity: 'See detail',
      },
      packageOffers: {
        duration: {
          stay: {
            days: 'Days',
            nights: 'Nights',
          },
          dates: {
            from: 'From',
            to: 'To',
          },
        },
        flight: {
          stops: 'Flight with layovers',
          noStops: 'Direct flight',
        },
        discountSave: 'Save',
        taxMessage: 'Taxes included',
      },
      map: {
        error: {
          title: 'Error displaying the map',
          description: 'Please try your search again.',
        },
        loading: 'Loading map...',
      },
      reservationDetail: {
        booking: 'Booking',
        reservationNumber: 'Despegar reservation number:',
        reservationCode: {
          hotel: 'Hotel reservation code:',
          flight: 'Flight reservation code:',
        },
        status: {
          cancelled: 'Cancelled',
          confirmed: 'Confirmed',
          in_process: 'In process',
          pending: 'Pending',
          affected: 'Affected',
          provider_control: 'Managed by supplier',
        },
      },
      specialRequest: {
        room: 'Room',
        rooms: 'Rooms',
        selectRoom: 'Choose where you will place your special order:',
        selectSpecialRequest: 'Choose the special order',
        placeholder: 'I want to add "{0}" for my hotel',
        send: 'Send to Sofia',
      },
      reschedulingCard: {
        nonstop: 'nonstop',
        stop: 'stop',
        stops: 'stops',
        seeFlight: 'Continue',
        seeAlternatives: 'Continue',
        seeAlternativesPrompt: 'I want to see more rescheduling alternatives for my flight',
        duration: 'duration',
        modal: {
          title: 'Flight Confirmation',
          flightNumber: 'Flight No.',
          showOriginalFlight: 'Show original flight',
          hideOriginalFlight: 'Hide original flight',
          seeAlternatives: 'See alternatives',
          buttonConfirmation: 'Confirm this flight',
          layover: (duration: string, city: string) => `Layover of ${duration} in ${city}`,
          waitingAction: 'I am processing your flight change request, this may take a few minutes, please wait.',
          localDateDisclaimer: 'Local time for each city.',
          totalDuration: 'Duration',
          layoverWaiting: 'Wait of',
          layoverIn: 'in',
        },
      },
      webCheckIn: {
        title: 'Flight to {0}',
      },
      contactBoard: {
        phone: 'Phone',
        call: 'Call',
        viewPhones: 'View phones',
        reservationNumberReminder: 'Please have your booking number ready.',
        localNumber: 'Calls within the country:',
        exteriorNumber: 'Calls from abroad:',
        goToWhatsapp: 'Open WhatsApp',
        preferWebchat: 'If you prefer, you can chat via',
        phonesModalTitle: 'Our phone numbers',
      },
    },
    productTour: {
      close: 'Got it',
      next: 'Next',
      prev: 'Previous',
      initTour: {
        step1: {
          title: 'Chat with SOFIA',
          text: 'Write to ask whatever you want: destination suggestions, travel tips, flights, and even fun facts.',
          text_mobile: 'By tapping here, you open the chat to ask whatever you want: destination suggestions, travel tips, flights, and even fun facts.',
        },
        step2: {
          title: 'Your information board',
          text: "When we have additional information to SOFIA response, you'll see it here.",
        },
        step3: {
          title: 'You can interact with the board',
          text: 'With these buttons, you can ask for more information about that topic to the chat without needing to write a question.',
          text_mobile: 'When you see these buttons, you can use them to continue the conversation. Remember that you can still write whatever you want by opening the chat.',
        },
      },
      flightOffers: {
        step1: {
          title: 'Use the chat to filter',
          text: 'Ask SOFIA for direct or connecting flights, with or without luggage, one way only, etc.',
        },
      },
      copyMessage: {
        step1: {
          title: 'We paste here the messages you copy',
          text: 'You can adjust them and resend them to SOFIA so she can understand them better.',
        },
      },
      favProduct: {
        step1: {
          title: 'Tap the heart to save to Favorites',
        },
      },
      newChat: {
        step1: {
          title: 'Chat history and new chat',
          text: 'Enter to view your previous conversations or start a new one.',
        },
      },
    },
    feedbackForm: {
      title: 'Feedback',
      send: 'Send',
      placeholder1: 'Write here..',
      question1: 'On a scale of 0 to 10, how likely are you to recommend SOFIA to a friend or colleague?',
      placeholder2: 'Write here..',
      question2: 'Why? It helps us a lot to know if you noticed any errors, if something seemed very good to you, and to know details of your experience.',
      close: 'Close',
    },
    distributionModal: {
      error: 'We had a problem. Please try again.',
      errorDistribution: 'There is no availability on this flight for this number of passengers. Sorry for the inconvenience.',
      title: 'Select passengers',
      adults: {
        title: 'Adults',
        description: 'From 18 years old',
      },
      minors: {
        title: 'Minors',
        description: 'Up to 17 years old',
        ageTitle: "Minor's age",
        ageDescription: 'At the end of the trip',
        labelSelect: 'Age',
        underOneAge: 'Up to 1',
      },
      close: 'Close',
    },
    previousChatModal: {
      title: "It's great to have you back here!",
      close: 'Close',
      text: 'I see we were talking.',
      question: 'Would you like to continue our previous conversation or start a new one?',
      cancel: 'Start new',
      recover: 'Continue',
    },
    flightDetailModal: {
      departure: 'Departure',
      return: 'Return',
      cabinType: {
        economy: 'Economy',
        business: 'Business',
        firstclass: 'First Class',
        premium_economy: 'Premium Economy',
        premium_business: 'Premium Business',
        premium_firstclass: 'Premium First Class',
      },
      rating: {
        veryGood: 'Very Good',
        good: 'Good',
        regular: 'Regular',
        bad: 'Bad',
      },
      duration: 'Duration',
      flight: 'Flight',
      class: 'Class',
      layover: {
        wait: 'Wait of',
        in: 'layover in',
        planeChange: 'Change planes',
        samePlane: 'Same plane',
      },
      localTime: 'Times expressed in local time for each city',
      baggage: {
        title: 'Baggage',
        backpack: {
          included: {
            title: 'Backpack or handbag included',
            description: 'Must fit under the front seat.',
          },
          notIncluded: {
            title: 'Backpack or handbag not included',
            description: '',
          },
        },
        handbag: {
          included: {
            title: 'Carry-on baggage included',
            description: 'Must fit inside the airplane compartment.',
          },
          notIncluded: {
            title: 'Carry-on baggage not included',
            description: '',
          },
        },
        suitcase: {
          included: {
            title: 'Checked baggage included',
            description: (quantity: number) => `${quantity} ${quantity > 1 ? 'bags' : 'bag'} per adult. It’s dispatched during the Check-in at the airport.`,
          },
          notIncluded: {
            title: 'Checked baggage not included',
            description: 'You can buy bags online for an exclusive price.',
          },
        },
      },
    },
    downloadAppModal: {
      subtitle: 'DISPONIBLE EN iOS Y ANDROID',
      title: 'Download the app to chat with SOFIA',
      description: 'Discover how our AI assistant can help you find the perfect destination for your next vacation.',
      button: 'Download now',
      href: 'https://m7sd.adj.st/www.despegar.com/sofia?adj_t=1f59te9q_1fpkb7np&adj_campaign=SiteMobile&adj_deep_link=https%3A%2F%2Fwww.despegar.com%2Fsofia%3Fclt_c%3D%26clt_cm%3DSiteMobile%26clt_d%3Dm%26clt_pr%3DG%26clt_cc%3DBR%26clt_n%3Dmd%26key%3DUT81AK9JAFEGJ4D69OVO6J673E',
    },
    editTextModal: {
      title: 'Change title',
      close: 'Close',
      send: 'Change',
      changeTitle: 'Title',
      changeDescription: (location?: string) => `Summary of the day ${location ? `in ${location}` : ''}`,
      error: {
        emptyTitle: 'Title cannot be empty',
      },
      prefix: {
        tripTitle: 'Change the trip title to:',
        tripDayTitle: day => `Change the title of day ${day} to:`,
        tripDayDescription: (day, location) => `Change the description of day ${day} ${location ? `in ${location}` : ''} to:`,
      },
      message: {
        title: 'Is there anything you want to change this day?',
        text: 'Adjust or delete the texts, we will take them into account to build a perfect day for you.',
      },
    },
    itineraryMapModal: {
      title: 'Itinerary map',
      close: 'Close',
    },
    tripPlanner: {
      day: 'Day',
      showMap: 'Show map',
      hasFavorite: 'In your favorites',
      hasPurchase: 'You have a reservation',
      reviews: (quantity: number) => `${quantity} user ${quantity === 1 ? 'review' : 'reviews'}`,
      tips: 'Travel tips',
    },
    chatsDrawer: {
      noChats: 'Here you will find your conversations with Sofia.',
      newChat: 'Start new conversation',
      feedback: {
        text: 'Can you help us improve?',
        button: 'Send feedback',
      },
    },
    favorites: {
      success: 'Saved in Favorites.',
      info: 'Removed from Favorites.',
      error: "We couldn't complete the action. Please try again.",
      warning: 'You have reached the maximum number of saved favorites.',
    },
    select: {
      defaultOption: 'Select an option',
    },
  },
};
